function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import classnames from 'classnames';
import Button from "./Button";
import ConfirmationButton from "./ConfirmationButton";
import Col from "./Col";
import Icon from "./Icon";
import Row from "./Row";
import Tooltip from "./Tooltip";

var noop = function noop() {
  return undefined;
};

var count = 0;

function getID() {
  return "hmf-".concat(count += 1); // eslint-disable-line no-return-assign
}

var HasManyFieldsRow = function HasManyFieldsRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabledReason = _ref.disabledReason,
      _ref$onDelete = _ref.onDelete,
      onDelete = _ref$onDelete === void 0 ? noop : _ref$onDelete,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disabledReasonPl = _ref.disabledReasonPlacement,
      disabledReasonPlacement = _ref$disabledReasonPl === void 0 ? 'top' : _ref$disabledReasonPl,
      _ref$deletable = _ref.deletable,
      deletable = _ref$deletable === void 0 ? true : _ref$deletable,
      deleteProps = _ref.deleteProps,
      props = _objectWithoutProperties(_ref, ["children", "className", "disabledReason", "onDelete", "disabled", "disabledReasonPlacement", "deletable", "deleteProps"]);

  var _useState = useState(getID()),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  var classNames = classnames('mb-4', className); // The `disabled ? <Button> : <ConfirmationButton>` code works around Tooltips not show on `disabled` elements:

  var tooltip = disabled && disabledReason ? /*#__PURE__*/React.createElement(Tooltip, {
    placement: disabledReasonPlacement,
    target: id
  }, disabledReason) : null;
  var button = disabled ? /*#__PURE__*/React.createElement(Button, {
    id: id,
    color: "danger",
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    outline: true,
    className: "p-2 disabled"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "times-circle-o",
    size: "lg"
  })) : /*#__PURE__*/React.createElement(ConfirmationButton, _extends({
    color: "danger",
    confirmation: "Delete",
    "aria-label": "Delete",
    outline: true,
    onClick: onDelete,
    className: "p-2"
  }, deleteProps), /*#__PURE__*/React.createElement(Icon, {
    name: "times-circle-o",
    size: "lg"
  }));
  return /*#__PURE__*/React.createElement(Row, _extends({
    className: classNames,
    noGutters: true
  }, props), /*#__PURE__*/React.createElement(Col, null, children), deletable && /*#__PURE__*/React.createElement(Col, {
    xs: "auto",
    className: "js-delete-col pl-3 d-flex"
  }, button, tooltip));
};

HasManyFieldsRow.displayName = "HasManyFieldsRow";
HasManyFieldsRow.defaultProps = {
  disabledReasonPlacement: 'top',
  disabled: false,
  onDelete: noop,
  deletable: true
};
HasManyFieldsRow.displayName = 'HasManyFieldsRow';
export default HasManyFieldsRow;